import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CustomButton from "../../ui/button/Button";

const EDTModalEditar = ({ selectedEDT, open, onClose, onConfirm }) => {
  const [nombre, setNombre] = useState(selectedEDT?.nombre || "");
  const handleClose = () => {
    onClose();
    setNombre("");
  };

  useEffect(() => {
    if (selectedEDT) {
      setNombre(selectedEDT.nombre);
    }
  }, [selectedEDT]);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Editar Estructura de desgloce de trabajo</DialogTitle>
      <DialogContent>
        <label htmlFor="editarE">Nombre:</label>
        <input
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          className="form-input"
          type="text"
          id="editarE"
        />
      </DialogContent>
      <DialogActions>
        <CustomButton
          background={"#FFFFFF"}
          color={"#223D51"}
          text="Cancelar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          onClick={onClose}
          type="button"
        />
        <CustomButton
          background={"#223D51"}
          color={"#FFFFFF"}
          text="Guardar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          onClick={() => {
            onConfirm(nombre);
          }}
          type="button"
        />
      </DialogActions>
    </Dialog>
  );
};

export default EDTModalEditar;
